<div class="banner">
  <div>
    @if (content.labels.title) {
      <span class="banner-container__title">
        {{ content.labels.title }}
      </span>
    }
    @if (content.labels.subtitle) {
      <span>
        {{ content.labels.subtitle }}
      </span>
    }
  </div>
  <div>
    @if (content.image.show) {
      <img
        class="banner-card__image"
        [src]="content.image.src"
        [alt]="content.image.alt"
      />
    }
    <span class="sr-only">{{ content.image.alt }}</span>
  </div>
</div>
